<template>
  <div class="category-container">
    <pageTitle>追溯码（袋码）信息管理</pageTitle>

    <div class="main">
      <el-button type="primary" plain @click="addBagCodeDialog=true">生成追溯码（袋码）</el-button>
      <el-dialog title="生成追溯码（袋码）" :visible.sync="addBagCodeDialog" @close="closeAddBagCodeDialog">
        <el-form :model="addBagCodeData" ref="addBagCodeData" :rules="addBagCodeRules" label-width="200px">
          <el-form-item label="生成追溯码数量" prop="code_number">
            <el-input-number v-model="addBagCodeData.code_number" :min="1" :max="100000" label="描述文字"></el-input-number>
          </el-form-item>
          <el-form-item label="品种名称" prop="checkedVarietyIndex">
            <el-select v-model="addBagCodeData.checkedVarietyIndex" placeholder="请选择品种名称">
              <el-option v-for="(item,index) in varietyListData" :key="item.id" :label="item.variety_name"
                         :value="index"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="公司名称" prop="checkedCompanyIndex">
            <el-select v-model="addBagCodeData.checkedCompanyIndex" placeholder="请选择公司名称">
              <el-option v-for="(item,index) in companyListData" :key="item.id" :label="item.company_name"
                         :value="index"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="closeAddBagCodeDialog">取 消</el-button>
          <el-button type="primary" @click="addBagCode('addBagCodeData')">确 定</el-button>
        </div>
      </el-dialog>


      <div class="categoryList">
        <el-table :data="bagCodeRecodeListData" stripe style="width:100%;margin-bottom: 35px;">
          <el-table-column width="150px" prop="code_number" label="生成追溯码数量"></el-table-column>
          <el-table-column width="300px" prop="filename" label="生成追溯码文件名称"></el-table-column>
          <el-table-column width="350px" prop="company_name" label="企业名称"></el-table-column>
          <el-table-column width="160px" prop="variety_name" label="品种名称"></el-table-column>
          <el-table-column width="180px" prop="create_time" label="生成时间"></el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <a v-if="downloadBagCodeFileUrl" :href="'https://api.wwzhuisu.cn/bagCodes/'+scope.row.filename"
                 :download="scope.row.filename">
                <el-button type="primary" plain>
                  下载追溯码文件包
                </el-button>
              </a>
              <a v-else :href="'http://127.0.0.1:8000/bagCodes/'+scope.row.filename" :download="scope.row.filename">
                <el-button type="primary" plain>
                  下载追溯码文件包
                </el-button>
              </a>
            </template>
          </el-table-column>
        </el-table>
      </div>

    </div>
  </div>
</template>

<script>
import pageTitle from "../components/pageTitle";

export default {
  name: "category",
  components: {
    pageTitle
  },
  data() {
    return {
      //生成追溯码数据
      addBagCodeData: {},
      //生成追溯码数据验证规则
      addBagCodeRules: {
        code_number: [
          {required: true, message: '请输入生成追溯码数量', trigger: 'blur'},
        ],
        checkedVarietyIndex: [
          {required: true, message: "请选择品种信息", trigger: "blur"}
        ],
        checkedCompanyIndex: [
          {required: true, message: "请选择公司信息", trigger: "blur"}
        ]
      },
      //追溯码列表数据
      bagCodeRecodeListData: null,

      //添加追溯码数据模态框
      addBagCodeDialog: false,

      //  企业列表数据
      companyListData: null,

      //  品种列表数据
      varietyListData: null,

      //  追溯码文件包下载地址
      downloadBagCodeFileUrl: true
    }
  },
  methods: {
    //获取追溯码数据
    getCodeRecode() {
      this.axios.post('generateBagCodeRecode/selectCodeRecode').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          this.bagCodeRecodeListData = success.data.data
        }
      })
    },

    //获取公司数据
    getCompanyListData() {
      this.axios.post('company/getCompanyList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          // success.data.data.create_time = success.data.data.create_time.substring(0, success.data.data.create_time.length - 3)
          this.companyListData = success.data.data
        }
      })
    },

    //获取品种数据
    getVarietyListData() {
      this.axios.post('variety/getVarietyList').then(success => {
        if (success.data.data) {
          for (const item in success.data.data) {
            success.data.data[item].create_time = success.data.data[item].create_time.substring(0, success.data.data[item].create_time.length - 4)
          }
          this.varietyListData = success.data.data
        }
      })
    },

    //添加追溯码（袋码）
    addBagCode(addBagCodeData) {
      this.$refs[addBagCodeData].validate((valiResult) => {
        if (valiResult) {
          let {code_number, checkedVarietyIndex, checkedCompanyIndex} = this.addBagCodeData

          this.axios.post('generateBagCodeRecode/generateCode', {
            "code_number": code_number - 0,
            "variety_id": this.varietyListData[checkedVarietyIndex].id,
            "variety_name": this.varietyListData[checkedVarietyIndex].variety_name,
            "company_id": this.companyListData[checkedCompanyIndex].id,
            "company_name": this.companyListData[checkedCompanyIndex].company_name
          }).then(success => {
            if (success.data.errno === 0) {
              this.$message({
                type: 'success',
                message: '生成追溯码成功'
              })
              this.getCodeRecode()
              this.addBagCodeDialog = false
            } else {
              this.$message({
                type: 'error',
                message: success.data.message
              })
            }
          })
        } else {
          this.$message({
            type: 'error',
            message: '请按正确的规则将内容填写完整'
          })
        }
      })
    },

    //关闭生成追溯码Dialog---将Dialog内容清空
    closeAddBagCodeDialog() {
      this.addBagCodeDialog = false
      this.addBagCodeData = {}
      this.checkedVarietyIndex = null
      this.checkedCompanyIndex = null
    },
  },
  created() {
    this.getCodeRecode()
    this.getCompanyListData()
    this.getVarietyListData()

    //  判断当前执行环境，来确保下载的地址
    console.log(window.location.origin === 'http://127.0.0.1:8000')
    if (window.location.origin === 'http://127.0.0.1:8000') {
      this.downloadBagCodeFileUrl = false
    }
  }
}
</script>

<style scoped lang="scss">

.category-container {

  .main {
    margin-left: 10px;

    .categoryList {
      margin-top: 30px;

      ul {
        border-radius: 5px;
        overflow: hidden;

        li {
          list-style: none;
          height: 50px;
          line-height: 50px;
          border-bottom: 1px solid #707070;
          background-color: #DCDFE6;

          label {
            float: left;
            margin-left: 20px;
          }

          .el-button {
            float: right;
            margin-top: 5px;
            margin-right: 10px;
          }
        }

        li:hover {
          background-color: #c0c4cc;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/code.vue